var exports = {
  "button": "button__BLkjiK",
  "small": "small__0Ka95w",
  "medium": "medium__--z_MZ",
  "condensed": "condensed__KMsxsC",
  "iconOnly": "iconOnly__wD4Cad",
  "default": "default__fboR_8",
  "disabled": "disabled__guxnzu",
  "invisible": "invisible__WCMMyQ",
  "icon": "icon__KXL1kn",
  "text": "text__aq5W2T",
};

__webpack_require__.r(module.exports = exports);
